import Button from '@navi/web-ui/lib/primitives/Button/Button';
import Drawer from '@navi/web-ui/lib/primitives/Drawer/Drawer';
import { useEffect, useRef, useState } from 'react';
import Editor, { Monaco } from '@monaco-editor/react';
import { useDispatch } from 'react-redux';
import { creation, getTemplate, validate } from '../paramountActions';
import useGetTenant from '@cp/pages/Paramount/hooks/useGetTenant';

const CreateSegmentDrawer = (props: {
  showUploadDrawer: boolean;
  setShowUploadDrawer: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { showUploadDrawer, setShowUploadDrawer } = props;
  const editorRef = useRef<Monaco | null>(null);
  const dispatch = useDispatch();
  const tenant = useGetTenant();
  const [template, setTemplate] = useState('');

  useEffect(() => {
    getTemplate(tenant, 'SEGMENT').then(res => {
      setTemplate(res.data);
    });
  }, []);
  function handleEditorDidMount(editor: Monaco) {
    editorRef.current = editor;
  }
  const handleCreateSegment = () => {
    const value = editorRef?.current?.getValue();

    dispatch(
      creation({
        data: value,
        type: 'SEGMENT',
        tenant
      })
    );
    setShowUploadDrawer(false);
  };
  const handleValidateSegment = () => {
    const value = editorRef?.current?.getValue();
    dispatch(
      validate({
        data: value,
        type: 'SEGMENT',
        tenant
      })
    );
    setShowUploadDrawer(false);
  };
  return (
    <Drawer
      open={showUploadDrawer}
      showHeaderDivider={true}
      footer={
        <div className="flex justify-center gap-[20px]">
          <Button variant="primary" size="medium" onClick={handleCreateSegment} className="w-[50%]">
            create segment
          </Button>
          <Button
            variant="primary"
            size="medium"
            onClick={handleValidateSegment}
            className="w-[50%]"
          >
            validate segment
          </Button>
        </div>
      }
      onClose={() => {
        setShowUploadDrawer(false);
      }}
      disableOutsideClick={false}
      style={{ width: '450px', overflow: 'auto' }}
    >
      <Editor
        height="75vh"
        defaultLanguage="strategyLanguage"
        defaultValue="// some comment"
        onMount={handleEditorDidMount}
        value={template}
      />
    </Drawer>
  );
};

export default CreateSegmentDrawer;
